import { useState } from 'react';
import { campaignCopy } from '@discovr/features';
import { Button } from '../../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../components/ui/dialog';
import { useLastNonEmpty } from '../hooks/useLastNonEmpty';
import { holdNoteLengthError } from './ConfirmedTab.holdReasons';
import { HoldNoteField } from './HoldNoteField';

const copy = campaignCopy.creator.hold;

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  creatorName: string;
  busy: boolean;
  onCloseAutoFocus?: (event: Event) => void;
  onConfirm: (note: string) => void | Promise<void>;
}

export function ReleaseHoldDialog({ open, onOpenChange, creatorName, busy, onConfirm, onCloseAutoFocus }: Props) {
  const [note, setNote] = useState('');
  const shownName = useLastNonEmpty(creatorName);

  const lengthError = holdNoteLengthError(note);

  if (!open && note !== '') setNote('');

  const handleOpenChange = (next: boolean) => {
    if (!next) setNote('');
    onOpenChange(next);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="max-w-md" onCloseAutoFocus={onCloseAutoFocus}>
        <DialogHeader>
          <DialogTitle>{copy.releaseDialog.title(shownName)}</DialogTitle>
          <DialogDescription>{copy.releaseDialog.description}</DialogDescription>
        </DialogHeader>
        <HoldNoteField label={copy.note.labelOptional} value={note} onChange={setNote} error={lengthError} />
        <DialogFooter>
          <Button variant="outline" onClick={() => handleOpenChange(false)} disabled={busy}>
            {copy.dialog.cancel}
          </Button>
          <Button disabled={busy || lengthError !== null} onClick={() => onConfirm(note.trim())}>
            {copy.releaseDialog.confirm}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
